import { useContext } from 'react';
import { ProductCardContext } from './Provider';

export const useProductCardContext = () => {
    const context = useContext(ProductCardContext);

    return context;
};
